import Leaflet from 'leaflet'
import Layer from './Layer'
import { fromLatLngToSweref99Tm } from './sweref99Tm'
import { withMapContext } from './mapContext'

class DrawPolygonLayer extends Layer {
    
    constructor(props) {
        super(props)
        this.polygon = new Polygon()
        this.onClick = (event) => {
            this.polygon.addPoint([event.latlng.lat, event.latlng.lng])
            this.redraw()
        }
        this.onDblClick = (event) => {
            this.polygon.complete()
            this.redraw()
            setTimeout(this.fireCompleteEvent.bind(this), 200)
        }
        this.onMouseMove = (event) => {
            this.polygon.updateWaypoint([event.latlng.lat, event.latlng.lng])
            this.redraw()
        }
        this.onMouseOut = (event) => {
            this.polygon.updateWaypoint(undefined)
            this.redraw()
        }
    }

    createLayer() {
        return Leaflet.layerGroup()
    }

    afterAdd() {
        const map = this.props.map
        map.on('click', this.onClick)
        map.on('dblclick', this.onDblClick)
        map.on('mousemove', this.onMouseMove)
        map.on('mouseout', this.onMouseOut)
        map.doubleClickZoom.disable()
        map.getContainer().style.cursor = 'crosshair'
    }

    afterRemove() {
        const map = this.props.map
        map.off('click', this.onClick)
        map.off('dblclick', this.onDblClick)
        map.off('mousemove', this.onMouseMove)
        map.off('mouseout', this.onMouseOut)
        map.doubleClickZoom.enable()
        map.getContainer().style.cursor = null
    }

    redraw() {
        this.layer
            .clearLayers()
            .addLayer(this.polygonBorder())
            .addLayer(this.polygonInterior())
            .addLayer(this.incompleteSides())
    }

    polygonBorder() {
        return Leaflet.polygon(this.polygon.points, {
            color: this.props.color,
            stroke: false,
            interactive: false
        })
    }

    polygonInterior() {
        return Leaflet.polyline(this.polygon.points, {
            color: this.props.color,
            interactive: false
        })
    }

    incompleteSides() {
        return Leaflet.polyline(this.polygon.incompletePoints, {
            color: this.props.color,
            dashArray: '10',
            interactive: false
        })
    }

    fireCompleteEvent() {
        if (this.props.onComplete) {
            const projectedPoints = this.polygon.points.map(fromLatLngToSweref99Tm)
            this.props.onComplete(projectedPoints)
        }
    }

}

class Polygon {

    constructor() {
        this.reset()
    }

    addPoint(point) {
        if (!this._complete) {
            this._points.push(point)
        }
    }

    updateWaypoint(point) {
        if (!this._complete) {
            this._waypoint = point
        }
    }

    complete() {
        this._waypoint = undefined
        this._complete = true
    }

    reset() {
        this._points = []
        this._waypoint = undefined
        this._complete = false
    }

    get points() {
        return this._complete
            ? [...this._points, this._points[0]]
            : [...this._points]
    }

    get incompletePoints() {
        const pointCount = this._points.length
        if (pointCount === 0 || this._waypoint == null) {
            return []
        }
        else if (pointCount === 1) {
            return [this._points[0], this._waypoint]
        }
        else {
            return [this._points[0], this._waypoint, this._points[this._points.length - 1]]
        }
    }

}

export default withMapContext(DrawPolygonLayer)


// WEBPACK FOOTER //
// ./src/components/Leaflet/DrawPolygonLayer.js